"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isStaticHook = (action) => Boolean(action.hook);
const isRestHook = (action) => Boolean(action.hook_subscription || action.hook_notification);
function isInstantServiceAction(action) {
    return isStaticHook(action) || isRestHook(action);
}
exports.default = isInstantServiceAction;
